import documentReady from '../common/documentReady'
import { trackPageView } from '../common/tracking/facebook/track_page_view'

documentReady(trackPageView)
